import Component from '../core/Component'
import {
   CountUp
} from 'countup.js'


export default class PriceCounter extends Component {

   constructor(element) {
      super(element);
      this.radioOptions = element.querySelectorAll('input[type=radio]');
      this.counterSetting = {
         duration: 0.7,
         separator: ' ',
      }
   }

   prepare() {
      this.radioOptions.forEach((item => {
         item.onclick = () => {
            let period = item.getAttribute("data-period")
            this.countIt(period);
         }
      }))
   }

   countIt(period) {
      let plans = document.querySelectorAll(".pricing-item")
      for (let i = 0; i < plans.length; i++) {
         var priceContainer = plans[i].querySelector(".price-value span"),
         currentValue = parseInt(priceContainer.innerText.replace(/ /g, '')),
         targetValue = plans[i].getAttribute("data-price-period-" + period);
         if (currentValue != targetValue) {
            var counter = new CountUp(priceContainer, targetValue, this.counterSetting)
            counter.start();
         }
      }
   }
}